/* ===== Fix de autoplay para todos los videos del tema (deferred-media) =====
   1) Oculta el boton de play nativo de WebKit/Chrome que aparece encima del
      video cuando el dispositivo no lo reproduce solo (modo bajo consumo, etc).
   2) Le da tamano real al <deferred-media> (por defecto es inline 0x0): en
      Safari iOS el IntersectionObserver puede no disparar con elementos 0x0,
      y entonces el video nunca se inserta.
   3) Fuerza muted + playsinline + preload y relanza play() apenas se inserta.
   4) Si el navegador igual lo bloquea, arranca TODOS los videos al primer
      toque/scroll del usuario en cualquier parte de la pagina.
   5) Red de seguridad: si a los 2s un deferred-media sigue sin video y esta
      cerca de la pantalla, lo carga a mano (por si el observer no disparo). */

(function () {
  var style = document.createElement('style');
  style.textContent = [
    'deferred-media { display: block; width: 100%; height: 100%; min-height: 1px; }',
    'video::-webkit-media-controls { display: none !important; }',
    'video::-webkit-media-controls-start-playback-button { display: none !important; -webkit-appearance: none !important; opacity: 0 !important; }',
    'video::-webkit-media-controls-overlay-play-button { display: none !important; }',
    'video::-webkit-media-controls-panel { display: none !important; }',
    'video::-webkit-media-controls-enclosure { display: none !important; }',
    'video[autoplay] { pointer-events: none; }'
  ].join('\n');
  document.head.appendChild(style);
})();

function eznzzaForcePlay(video) {
  if (!video || video.closest('ez-card-motion')) return;
  video.muted = true;
  video.defaultMuted = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.setAttribute('autoplay', '');
  video.setAttribute('loop', '');
  video.setAttribute('preload', 'auto');
  video.removeAttribute('controls');
  if (video.readyState === 0 && video.networkState === 0) { try { video.load(); } catch (e) {} }
  var p = video.play();
  if (p && typeof p.catch === 'function') p.catch(function () {});
}

function eznzzaLoadPendingDeferred() {
  document.querySelectorAll('deferred-media').forEach(function (dm) {
    if (dm.isLoaded || dm.querySelector('video') || dm.classList.contains('autoplay-false')) return;
    var r = dm.getBoundingClientRect();
    var near = r.top < window.innerHeight + 1200 && r.bottom > -1200;
    if (near && typeof dm.loadContent === 'function') dm.loadContent();
  });
}

function eznzzaPlayAllVideos() {
  eznzzaLoadPendingDeferred();
  document.querySelectorAll('video').forEach(eznzzaForcePlay);
}

if (typeof DeferredMedia !== 'undefined') {
  var originalLoadContent = DeferredMedia.prototype.loadContent;
  DeferredMedia.prototype.loadContent = function () {
    if (this.isLoaded) return;
    originalLoadContent.call(this);
    if (this.video) eznzzaForcePlay(this.video);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  eznzzaPlayAllVideos();
  setTimeout(eznzzaPlayAllVideos, 1500);
  setTimeout(eznzzaPlayAllVideos, 4000);
});
window.addEventListener('load', eznzzaPlayAllVideos);

/* Primer gesto del usuario: reintenta reproducir todo (desbloquea iOS). */
['touchstart', 'touchend', 'scroll', 'click', 'keydown'].forEach(function (evt) {
  document.addEventListener(evt, eznzzaPlayAllVideos, { passive: true });
});

/* Si la pestana vuelve a estar visible, reintenta. */
document.addEventListener('visibilitychange', function () {
  if (!document.hidden) eznzzaPlayAllVideos();
});
